// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 966 ? "dashboard" : chunkId) + "." + {"44":"2251f57a","79":"d36c955e","410":"ef106dfa","962":"88223051","966":"54dd9924"}[chunkId] + ".js";
};